import { useState } from 'react';

const faqs = [
  {
    q: 'What is a CSSBuy spreadsheet?',
    a: 'A CSSBuy spreadsheet is a curated collection of product links, typically organized in Google Sheets or Excel format, that helps shoppers browse and purchase items from Chinese marketplaces through the CSSBuy agent platform. These spreadsheets include direct links to products on Taobao, Weidian, and 1688, along with pricing information, size charts, and quality assessments.',
  },
  {
    q: 'Is a Kakobuy spreadsheet better than CSSBuy?',
    a: 'It depends on what you are looking for. Kakobuy spreadsheets tend to focus on budget-friendly finds with competitive shipping rates, while CSSBuy spreadsheets often feature a broader range of products with more detailed QC photos. Many experienced shoppers maintain spreadsheets for both platforms and choose based on the specific item type and shipping destination.',
  },
  {
    q: 'Which agent has the cheapest spreadsheet items?',
    a: 'The underlying product prices are generally the same across agents since they all source from the same Chinese marketplaces. The real cost differences come from agent service fees, shipping rates, and conversion fees. CSSBuy typically offers lower service fees, while Superbuy provides more comprehensive quality inspection services that may justify the slightly higher cost for expensive items.',
  },
  {
    q: 'Are Superbuy spreadsheets reliable?',
    a: 'Yes, Superbuy spreadsheets are generally considered reliable, especially for higher-value purchases. Superbuy has a strong reputation for quality control photography and responsive customer service. Their spreadsheet community tends to focus on premium streetwear and sneaker categories where detailed inspection matters most.',
  },
  {
    q: 'How often are spreadsheets updated?',
    a: 'Quality spreadsheets are typically updated weekly or bi-weekly. Dead links are removed, new finds are added, and seasonal trend sections are refreshed. The best CSSBuy sheet maintainers update their databases at least once a week to ensure listings remain active and pricing stays current.',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Everything you need to know about agent shopping spreadsheets
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h4 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </h4>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4 animate-scale-in">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}